module.exports = __webpack_public_path__ + "assets/media/day24.81e3dd79.mp3";